import { useEffect, useState } from "react";
import { fetchGuestMaps, type GuestMap } from "./api.js";
import styles from "./Live.module.css";

/** A client participant's home: the value maps they are invited to (brief 8.2). */
export function GuestHome() {
  const [maps, setMaps] = useState<GuestMap[] | "failed" | null>(null);

  useEffect(() => {
    const ctl = new AbortController();
    fetchGuestMaps(ctl.signal).then(setMaps, (err: unknown) => {
      if ((err as Error).name !== "AbortError") setMaps("failed");
    });
    return () => ctl.abort();
  }, []);

  return (
    <main className={styles.guestWrap}>
      <div className={styles.card}>
        <div className={styles.eyebrow}>SalesFix Value Map Builder</div>
        <h1>Your value maps</h1>
        {maps === null && <p className={styles.note}>Loading…</p>}
        {maps === "failed" && (
          <p className={styles.error} role="alert">
            Your value maps could not be loaded. Please refresh the page.
          </p>
        )}
        {Array.isArray(maps) && maps.length === 0 && (
          <p className={styles.note}>
            You have not been invited to any value maps, or your access has ended. If you expected
            to see one, contact the SalesFix person who invited you.
          </p>
        )}
        {Array.isArray(maps) && maps.length > 0 && (
          <ul className={styles.mapList}>
            {maps.map((m) => (
              <li key={m.id}>
                <a href={`/maps/${encodeURIComponent(m.id)}`}>
                  <span>{m.title || "Untitled value map"}</span>
                  <span className={styles.tag}>{m.status}</span>
                </a>
              </li>
            ))}
          </ul>
        )}
        <p className={styles.hint}>
          Use business information only. Do not enter details about individual clients, patients,
          donors or members.
        </p>
      </div>
    </main>
  );
}
